<template>
  <!--v-chart ref="chart" :options="options" :init="chartInit" @contextmenu="contextmenu" /-->
  <v-chart ref="chart" :options="options" :init="chartInit" />
</template>

<script>
import { DEFAULT_COLORS } from '@/constants';
import chartable from '@/mixins/chartable';

export default {
  mixins: [chartable],
  props: {
    values: {
      type: Array,
      required: true,
    },
    colors: {
      type: Array,
      default() {
        return DEFAULT_COLORS;
      },
    },
    animation: {
      type: Boolean,
      default: false,
    },
    areaStyle: {
      type: String,
      default: 'normal',
    },
    contextmenu: {
      type: Function,
      default: e => e,
    },
    // BEGIN::Added.by.KWShin.2024.01.10.
    click: {
      type: Function,
      default: e => e,
    },
    // FINISH::Added.by.KWShin.2024.01.10.
  },
  data() {
    return {
      chartInit: {
        grid: {
          left: 0,
          right: 0,
          top: 0,
          bottom: 0,
        },
        xAxis: {
          axisLine: { show: false },
          splitLine: { show: false },
        },
        yAxis: {
          axisLine: { show: false },
          splitLine: { show: false },
        },
        tooltip: {
          trigger: 'item',
          transitionDuration: 0,
          formatter: '{b} : {c}',
          textStyle: {
            fontSize: 12,
          },
        },
      },
      // Added.by.KWShin.2024.01.11.
      options: {},
    };
  },
  // BEGIN::Removed.by.KWShin.2023.01.11
  // computed: {
  //   options() {
  //     return {
  //       animation: this.animation,
  //       color: this.colors,
  //       series: [
  //         {
  //           type: 'pie',
  //           center: ['50%', '50%'],
  //           label: { show: false },
  //           hoverAnimation: false,
  //           selectedMode: 'single',
  //           selectedOffset: 3,
  //           // radius: '100%',
  //           radius: ['50%', '100%'],
  //           data: (() => {
  //             // [{ name: 'name1', value: 1 }, { name: 'name2', value: 2 }];
  //             return this.itemStyle(this.values);
  //           })(),
  //         },
  //       ],
  //     };
  //   },
  // },
  // FINISH::Removed.by.KWShin.2023.01.11
  // BEGIN::Added.by.KWShin.2023.01.11
  watch: {
    values: {
      deep: true,
      handler() {
        this.setOptions();
      },
    },
    colors: {
      deep: true,
      handler() {
        this.setOptions();
      },
    },
  },
  // FINISH::Added.by.KWShin.2023.01.11
  methods: {
    // BEGIN::Added.by.KWShin.2023.01.11
    // options를 computed로 해 놓으면
    // Props 'values'가 변했을 때는 options가 알아서 변동이 된다.
    // 하지만, Props 'colors'가 변했을 때는 그렇지 않다.
    // 혹시나 DEFAULT_COLORS가 freeze() 되어 있어서 그런 것인가 하여 freezing을 하지 않아도 결과는 동일하다.
    // 방법이 없다. options를 computed에서 데이터로 옮기고
    // values와 colors를 watch하여 setOptions()를 호출하여 options를 변경하도록 했다.
    // 그런데, 그렇게 해도 Props 'colors'가 변경되었을 때는 options가 변경이 안된다.
    // 허거덕, 할 수 없이 부모쪽에서 color를 바꾸었을 때에는 setOptions() 메소드를 직접 호출하도록 하였다.
    setOptions() {
      this.options = {
        animation: this.animation,
        color: this.colors,
        series: [
          {
            type: 'pie',
            center: ['50%', '50%'],
            label: { show: false },
            hoverAnimation: false,
            selectedMode: 'single',
            selectedOffset: 3,
            // radius: '100%',
            radius: ['50%', '100%'],
            data: (() => {
              // [{ name: 'name1', value: 1 }, { name: 'name2', value: 2 }];
              return this.itemStyle(this.values);
            })(),
          },
        ],
      };
    },
    // FINISH::Added.by.KWShin.2023.01.11
    /**
     * 이 Pie.vue 컴포넌트틑 Whole view에서도 사용하지만
     * Preference의 ChartColor 설정 쪽에서도 사용한다.
     * 데이터별로 Pie 차트 조각의 색상을 지정하여야 하는데
     * 데이터가 없는 경우가 있을 수 있어 Whole view쪽에서 사용할 때는
     * 데이터 객체에 자신의 색상값의 순서를 지정하는 colorIndex 값을 물고 온다.
     * 하지만, ChartColor 설정 쪽에서는 그냥 순서대로 모든 색상의 경우를 설정하면 되기 때문에
     * colorIndex 값이 넘어오지 않으므로 아래 코드와 같이 로직이 작성되었다.
     * 2024.10.28.KWShin.
     */
    itemStyle(values) {
      return values.map((val, index) => {
        return {
          ...val,
          itemStyle: (() => {
            let style = {};
            if (this.areaStyle == 'gradation') {
              if (val.colorIndex) style = this.areaStyleGradation(this.colors[val.colorIndex]);
              else style = this.areaStyleGradation(this.colors[index]);
            } else if (this.areaStyle == 'linearGradient') {
              if (val.colorIndex) style = this.areaStyleLinearGradient(this.colors[val.colorIndex], 20, 40);
              else style = this.areaStyleLinearGradient(this.colors[index], 20, 40);
            } else if (this.areaStyle == 'spinLinearGradient') {
              if (val.colorIndex) style = this.areaStyleSpinLinearGradient(this.colors[val.colorIndex], 20, 40);
              else style = this.areaStyleSpinLinearGradient(this.colors[index], 20, 40);
            }
            return style;
          })(),
        };
      });
    },
  },
  // BEGIN::Added.by.KWShin.2024.01.10.
  // <v-chart> 컴포넌트에 @click으로 함수를 등록하면 패러미터로 항상 event object가 넘어와서
  // echart가 넘겨준다고 하는 params를 받을 수 있는 방법이 때려죽어도 없다.
  // 그래서 원초적인 방법으로 접근했더니... params가 넘어온다. 거참... 고생스럽네...
  mounted() {
    this.$refs.chart.$refs.chart.chart.on('click', this.click);
    this.$refs.chart.$refs.chart.chart.on('contextmenu', this.contextmenu);
  },
  // FINISH::Added.by.KWShin.2024.01.10.
};
</script>
